import React, { FC, useContext } from "react";
import { useTranslation } from "react-i18next";

import { Icon } from "@/components/Icon";
import { ISectionProps, Section } from "@/components/Section";
import { Text } from "@/components/Text";
import { UserContext } from "@/components/User";
import { formatFullName } from "@/data/persons";
import { IWOConfirmTask } from "@/data/tasks";
import { Flex } from "@/eworkitComponents/index";
import { isAssigneeAccountNotDeleted } from "@/views/Tasks/List/isAssigneeAccountNotDeleted";

interface IActOnBehalfMessageProps extends ISectionProps {
  task?: IWOConfirmTask;
}

export const ActOnBehalfMessage: FC<IActOnBehalfMessageProps> = ({ task, ...props }) => {
  const { contextConsultantProfile } = useContext(UserContext);
  const { t } = useTranslation("session");

  if (
    !task?.assignee ||
    !isAssigneeAccountNotDeleted(task.assignee) ||
    contextConsultantProfile?.id === task.assignee.id
  ) {
    return null;
  }

  return (
    <Section background="info" shadow="default" borderRadius padding={["md"]} {...props}>
      <Flex direction="row" align="center" innerMargin="sm">
        <Icon icon="info" color="white" size="lg" />
        <Text color="white">
          {t("TASKS.DETAILS.ACT_ON_BEHALF")} {formatFullName({ ...task.assignee })}
        </Text>
      </Flex>
    </Section>
  );
};
